import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import useI18n from 'hooks/I18n/useI18n';

import Text from 'components/ProductIdentity/Text.jsx';

const LRQDOBanner = ({ className }) => {
    const { trans } = useI18n();
    return (
        <div className={classNames('lrqdo-banner', className)}>
            <div className="lrqdo-banner-flex">
                <div>
                    <Text weight={700} size="16px" lineHeight="24px" color="turquoise2">
                        {trans('lrqdo.sale.banner.title')}
                    </Text>
                    <ul>
                        <li>
                            <Text size="14px" lineHeight="20px" color="turquoise2">
                                {trans('lrqdo.sale.banner.item1')}
                            </Text>
                        </li>
                        <li>
                            <Text size="14px" lineHeight="20px" color="turquoise2">
                                {trans('lrqdo.sale.banner.item2')}
                            </Text>
                        </li>
                        <li>
                            <Text size="14px" lineHeight="20px" color="turquoise2">
                                {trans('lrqdo.sale.banner.item3')}
                            </Text>
                        </li>
                    </ul>
                </div>
                <div>
                    <img src="/assets/images/banners/lrqdo-sale-banner.jpg"></img>
                </div>
            </div>
        </div>
    );
};

LRQDOBanner.propTypes = {
    className: PropTypes.string,
};

export default LRQDOBanner;
